module.exports = __webpack_public_path__ + "static/mt-scrollable-9673d09fcc3aa0212e8b774e4e3c6e74.png";